import React, { useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

import { JSONEditor } from "../ManageWorkflow/JSONEditor";
import { SimpleModal } from "../../../components/Modals/SimpleModal";
import { POST } from "../../../api/requests";
import Button from "../../../components/Button";
import NavBanner from "../../../components/Banners/NavBanner";
import { useDialog } from "../../../contexts/DialogContext";

export default function ManageScheduledWorkflowVariant() {
  const { workflowId } = useParams();
  const navigate = useNavigate();
  const { openDialog } = useDialog();

  const [title, setTitle] = useState("");
  const [contextObject, setContextObject] = useState("{}");

  const { mutate: createContextObjectMutation, isLoading } = useMutation(
    (formData) => POST(`/workflows/${workflowId}/scheduled`, formData),
    {
      onSuccess: () => {
        navigate(-1);
      },
      onError: (error) => {
        openDialog(
          <SimpleModal
            titleText="There was an error"
            bodyText={`Received this from the server: ${
              error.message || "unknown error"
            }`}
            variant="error"
          />
        );
      },
    }
  );

  const handleSave = async () => {
    const formData = {
      title,
      contextObject,
    };

    createContextObjectMutation(formData);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <NavBanner />
      <div className="mx-auto max-w-5xl px-4 py-6 sm:px-12 lg:px-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-8">
          Add new variant
        </h1>

        {/* title */}
        <div>
          <label
            htmlFor="title"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Title
          </label>
          <div className="mt-1 mb-8">
            <input
              id="title"
              name="title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Variant title"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        {/* context object */}
        <JSONEditor
          label="Context object"
          value={contextObject}
          onChange={setContextObject}
          height="500"
        />

        {/* save and cancel buttons */}
        <div className="flex items-center justify-end gap-x-3 pb-8 -mt-4">
          <Button
            label="Go back"
            onClick={handleGoBack}
            style="filled"
            rounded="md"
            variant="secondary"
          />
          <Button
            label="Save variant"
            onClick={handleSave}
            style="filled"
            rounded="md"
            disabled={isLoading}
          />
        </div>
      </div>
    </>
  );
}
